import { ContentPage } from '../page-factory/content-page';
import { kumbh2025Page } from '../pages/page-kumbh-2025';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(kumbh2025Page);

export default function Kumbh2025Page() {
  return <ContentPage {...kumbh2025Page} />;
}
